import { render, staticRenderFns } from "./QualificationRecords.vue?vue&type=template&id=ae96f176&scoped=true"
import script from "./QualificationRecords.vue?vue&type=script&lang=ts"
export * from "./QualificationRecords.vue?vue&type=script&lang=ts"
import style0 from "./QualificationRecords.vue?vue&type=style&index=0&id=ae96f176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae96f176",
  null
  
)

export default component.exports